import AxiosApi from "@/config/axios";

const CopartService = {};

CopartService.getUtilizationValue = () => {
    return AxiosApi({
        url: `/utilizations/last-value`,
        method: 'get',
    })
}


export default CopartService;